module.exports = __webpack_public_path__ + "static/img/flag-united-kingdom.3afed3e.png";